var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 2C3.83696 2 3.20107 2.26339 2.73223 2.73223C2.26339 3.20107 2 3.83696 2 4.5V8.379C2.00014 9.04174 2.26343 9.67731 2.732 10.146L10.232 17.646C10.4642 17.8782 10.7398 18.0624 11.0431 18.1881C11.3465 18.3138 11.6716 18.3785 12 18.3785C12.3284 18.3785 12.6535 18.3138 12.9569 18.1881C13.2602 18.0624 13.5358 17.8782 13.768 17.646L17.646 13.768C17.8782 13.5358 18.0624 13.2602 18.1881 12.9569C18.3138 12.6535 18.3785 12.3284 18.3785 12C18.3785 11.6716 18.3138 11.3465 18.1881 11.0431C18.0624 10.7398 17.8782 10.4642 17.646 10.232L10.146 2.732C9.67755 2.26368 9.0424 2.00041 8.38 2H4.5ZM5 6C5.26522 6 5.51957 5.89464 5.70711 5.70711C5.89464 5.51957 6 5.26522 6 5C6 4.73478 5.89464 4.48043 5.70711 4.29289C5.51957 4.10536 5.26522 4 5 4C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5C4 5.26522 4.10536 5.51957 4.29289 5.70711C4.48043 5.89464 4.73478 6 5 6Z",
    fill: "#0D9488"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.7c1676dedc6059c4b7a5970416e3e10e.svg";
export { ForwardRef as ReactComponent };